<div class="container main-container">
  <!-- Slider main container -->
  <div class="titles titles-head">
    <h5 style="
margin-bottom: 5px;
">Only Play the Big Jackpots</h5>
    <h2>Activate your Jackpot Trigger</h2>
    <h5 style="margin-top: 10px;line-height: 22px;">No strings attached, we automatically <br/>put you in the draw when it’s a high jackpot.</h5>
  </div>
  <swiper [config]="SliderOptions" class="swiper-inbox">
    <ng-template swiperSlide class="slide">
      <div class="swiper-slide slide_1">
        <div class="slide_content">
           <div class="titles">
             <p><span>Step 1</span>Go to the Store</p>
           </div>
           <div class="img-block">
            <span (click)="goToStore()">
              <img src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/inbox%2F1.png?alt=media&token=7aa1da57-4dfa-44a4-ab7b-10f74a111b15">
              </span>
           </div>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide class="slide">
      <div class="swiper-slide slide_2">
        <div class="slide_content">
           <div class="titles">
             <p><span>Step 2</span>Select the lottery to <br/>add your Trigger</p>
           </div>
           <div class="img-block">
            <span (click)="goToStore()">
             <img src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/inbox%2F2.png?alt=media&token=ed81ab94-e4f6-4b62-9a24-1596eed029b5">
            </span>
           </div>
        </div>
      </div>
    </ng-template>
    <ng-template swiperSlide class="slide">
      <div class="swiper-slide slide_3">
        <div class="slide_content">
           <div class="titles">
             <p><span>Step 3</span>Finally, Activate your <br/>Jackpot Trigger!</p>
           </div>
           <div class="img-block">
            <span (click)="goToStore()">
             <img src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/inbox%2F3.png?alt=media&token=1a8a5698-1628-4267-b5d2-f476193824f2">
            </span>
           </div>
        </div>
      </div>
    </ng-template>
  </swiper>
  <a class="oklink" (click)="goToStore()">Ok thanks</a>
</div>